var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogosVisa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 20,
    viewBox: "0 0 61 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1119_26793)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.7454 6.65371C31.7112 9.35277 34.1508 10.8589 35.9885 11.7544C37.8766 12.6732 38.5109 13.2624 38.5034 14.0841C38.4893 15.3415 36.9973 15.8965 35.6011 15.9181C33.1652 15.9558 31.7489 15.2604 30.623 14.7345L29.7455 18.8405C30.8752 19.3611 32.967 19.815 35.1361 19.835C40.2279 19.835 43.5591 17.3215 43.5771 13.4246C43.597 8.47879 36.7362 8.20504 36.783 5.99442C36.7992 5.3241 37.4388 4.60879 38.8404 4.42692C39.5341 4.33504 41.4492 4.26473 43.6205 5.26457L44.4727 1.29192C43.305 0.866762 41.8043 0.459652 39.9359 0.459652C35.1434 0.459652 31.7726 3.00731 31.7454 6.65371ZM52.6613 0.80184C51.7315 0.80184 50.948 1.34418 50.5983 2.17645L43.3249 19.5432H48.413L49.4255 16.745H55.643L56.2303 19.5432H60.7148L56.8015 0.80184H52.6613ZM53.373 5.86457L54.8414 12.9021H50.82L53.373 5.86457ZM25.5764 0.802074L21.5658 19.5429H26.4143L30.423 0.801605L25.5764 0.802074ZM18.4038 0.802074L13.3573 13.5579L11.3159 2.71176C11.0763 1.50098 10.1304 0.80184 9.07992 0.80184H0.830391L0.714844 1.34606C2.40844 1.71356 4.33266 2.30629 5.49844 2.94051C6.21187 3.32793 6.41531 3.6666 6.64969 4.58723L10.5162 19.5432H15.6398L23.4952 0.80184L18.4038 0.802074Z",
    fill: "url(#paint0_linear_1119_26793)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1119_26793",
    x1: 2759.15,
    y1: 58.7018,
    x2: 2815.24,
    y2: -1931.17,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#222357"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#254AA5"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1119_26793"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 19.4531,
    fill: "white",
    transform: "translate(0.714844 0.457031)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogosVisa);
export default __webpack_public_path__ + "static/media/logos-visa.8d78698c6465ac166dd36c04b73ef8f3.svg";
export { ForwardRef as ReactComponent };